export default __webpack_public_path__ + "6720a13c9b7754f4a12a8ad8784a88c4.png";